import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, styled, Button, keyframes } from '@mui/material';
import { User } from 'firebase/auth';
import { NavbarButton } from './NavbarButton';
import { WHITE, GREY1 } from '../../constants/colors';

const slideInRight = keyframes`
  from {
    transform: translateX(10%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const DropdownContainer = styled(Paper)(() => ({
  position: 'absolute',
  top: 'calc(100% - 4px)',
  left: '-60px',
  width: '240px',
  height: '132px',
  backgroundColor: WHITE,
  boxShadow: '0px 4px 4px 0px #00000040',
  borderRadius: '4px',
  padding: '6px 4px',

  zIndex: 1500,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  animation: `${slideInRight} 300ms ease-out`,
}));

const DropdownItem = styled(Button)(() => ({
  width: '232px',
  height: '40px',
  padding: '0 16px',
  borderRadius: '4px',
  color: GREY1,


  fontFamily: '"Noto Sans TC", sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '20px',
  textAlign: 'left',
  justifyContent: 'left',
  margin: '0 auto',

  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:active': {
    backgroundColor: 'transparent',
  },
}));



interface UserDropdownProps {
  user: User;
}

export const UserDropdown = ({ user }: UserDropdownProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => setOpen(true);
  const handleMouseLeave = () => setOpen(false);

  const userName = user.displayName || user.email || 'User';

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        position: 'relative',
        display: 'inline-block',
        paddingBottom: '8px',
        marginBottom: '-8px'
      }}
    >
      <NavbarButton
        disableRipple
      >
        {userName}
      </NavbarButton>

      {open && (
        <DropdownContainer elevation={0}>
          <DropdownItem onClick={() => navigate(`/profile/${user.uid}`)} disableRipple>
            個人資料
          </DropdownItem>

          <DropdownItem onClick={() => navigate('/edit/profile')} disableRipple>
            編輯個人資料
          </DropdownItem>

          <DropdownItem onClick={() => navigate('/signout')} disableRipple>
            登出
          </DropdownItem>
        </DropdownContainer>
      )}
    </Box>
  );
};
